import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BCP, BCPPYME, CALLCENTER } from "../../channels/constants/channels";
import { datalayer } from "../datalayer";

export type DatalayerVirtualPageMapping = Record<
    string,
    { pagePath: string; pageName: string }
>;

export const useDatalayerVirtualPage = (
    virtualPagesMapping: DatalayerVirtualPageMapping
) => {
    const { pathname } = useLocation();

    let filtredPathName = pathname;
    if (pathname.indexOf(BCPPYME) != -1) {
        filtredPathName = pathname.split("/" + BCPPYME)[1];
    }

    const channel = filtredPathName ? filtredPathName.substring(1) : null;
    if (channel === CALLCENTER || channel === BCP || !filtredPathName) {
        filtredPathName = "/";
    }

    useEffect(() => {
        const mapping = virtualPagesMapping[filtredPathName];
        if (!mapping) return;
        datalayer.push({
            event: "virtualPage",
            pagePath: mapping.pagePath,
            pageName: mapping.pageName,
        });
    }, [filtredPathName]);
};
